/* ==========================================================================
   FIND YOUR KAIVO MATCH
   Blend data comes from #kaivo-match-data, which sections/kaivo-match.liquid
   builds from the products' own metafields. Nothing about a blend is written
   in this file.
   ========================================================================== */
(function () {
  'use strict';

  var dataEl = document.getElementById('kaivo-match-data');
  if (!dataEl) return;

  var DATA;
  try { DATA = JSON.parse(dataEl.textContent); }
  catch (e) { return; }

  var BLENDS = DATA.blends || [];
  if (!BLENDS.length) return;

  /* ------------------------------------------------------------- matching */

  // Store values are written for customers, not for code: "Pour Overs",
  // "Cappuccinos", "12-16 hours brewed iced". We match on a lowercased
  // substring so plurals and rewording keep working.
  function norm(v) { return String(v || '').toLowerCase(); }

  function listHits(storeValues, answers) {
    if (!storeValues || !storeValues.length) return false;
    for (var i = 0; i < storeValues.length; i++) {
      var v = norm(storeValues[i]);
      for (var j = 0; j < answers.length; j++) {
        var needles = answers[j].match || [answers[j].value];
        for (var k = 0; k < needles.length; k++) {
          if (v.indexOf(norm(needles[k])) > -1) return true;
        }
      }
    }
    return false;
  }

  // Flavour values are a locked dropdown in the admin, so they can be
  // compared exactly.
  function flavourScore(blend, flavours) {
    var best = 0;
    for (var i = 0; i < flavours.length; i++) {
      var f = flavours[i].value;
      if ((blend.flavourPrimary || []).indexOf(f) > -1)        best = Math.max(best, 2);
      else if ((blend.flavourSecondary || []).indexOf(f) > -1) best = Math.max(best, 1);
    }
    return best;
  }

  var RARITY = { 'the-wildcard-whole-beans': -0.5 };
  var HOUSE_ORDER = [
    'the-daily-swing-whole-beans',
    'the-roar-whole-beans',
    'the-slow-charge-whole-beans',
    'the-leap-whole-beans',
    'the-wildcard-whole-beans'
  ];

  function score(blend, styles, equip, flavours) {
    var s = 0;
    if (listHits(blend.equipment, equip)) s += 4;   // binary, not per selection
    s += flavourScore(blend, flavours);
    if (listHits(blend.styles, styles))   s += 1;   // binary
    return s + (RARITY[blend.handle] || 0);
  }

  function match(styles, equip, flavours) {
    styles   = styles.filter(function (o) { return !o.none; });
    flavours = flavours.filter(function (o) { return !o.none; });

    if (equip.some(function (o) { return o.value === 'none'; })) {
      var key = flavours.length === 1 ? flavours[0].value : '__fallback';
      var handle = DATA.dripMap[key] || DATA.dripMap.__fallback;
      return { route: 'drip', product: DATA.drip[handle] };
    }

    var scored = BLENDS.map(function (b) {
      return { blend: b, score: score(b, styles, equip, flavours) };
    }).sort(function (a, b) {
      return b.score - a.score
        || HOUSE_ORDER.indexOf(a.blend.handle) - HOUSE_ORDER.indexOf(b.blend.handle);
    });

    var tied = scored.filter(function (x) { return x.score === scored[0].score; });

    // Two level -> the pack of 2, both pre-filled. Three or more -> the full range.
    if (tied.length === 2) return { route: 'sampler2', pair: [tied[0].blend, tied[1].blend] };
    if (tied.length >= 3)  return { route: 'sampler5' };
    return { route: 'one', blend: scored[0].blend };
  }

  /* ------------------------------------------------------------ questions */

  var STEPS = [
    {
      id: 'know', multi: false,
      q: 'Do you know how you like your coffee?',
      sub: "If you already have a favourite, we won't waste your time.",
      opts: [
        { value: 'no',  label: "No, I don't know yet", desc: "Four quick questions and we'll find it" },
        { value: 'yes', label: 'Yes, I know what I like', desc: "Then we'll point you at something different" }
      ]
    },
    {
      id: 'style', multi: true,
      q: 'What is your go-to coffee order at a cafe?',
      sub: 'Select all that apply.',
      opts: [
        { value: 'Cappuccino', match: ['cappuccino'], label: 'Cappuccino', desc: 'Milky, creamy & comforting' },
        { value: 'Flat White', match: ['flat white'], label: 'Flat White', desc: 'Smooth, creamy & coffee-forward' },
        { value: 'Cortado',    match: ['cortado'],    label: 'Cortado',    desc: 'Balanced, with a little milk' },
        // Americano is how the store words black coffee.
        { value: 'Black',      match: ['americano'],  label: 'Black Coffee', desc: 'Just coffee, no milk' },
        { value: 'Iced',       match: ['iced', 'cold brew'], label: 'Iced Coffee / Cold Brew', desc: 'Cold, refreshing & easy' },
        { value: 'depends', none: true, label: 'It depends', desc: 'A little bit of everything' }
      ]
    },
    {
      id: 'equip', multi: true,
      q: 'How do you brew your coffee at home?',
      sub: 'Select all that apply.',
      opts: [
        { value: 'Espresso Machine', match: ['espresso machine'], label: 'Espresso Machine' },
        { value: 'Moka Pot',         match: ['moka'],             label: 'Moka Pot' },
        { value: 'French Press',     match: ['french press'],     label: 'French Press' },
        { value: 'Pour Over',        match: ['pour over'],        label: 'Pour Over / V60 / Chemex' },
        { value: 'Aeropress',        match: ['aeropress'],        label: 'Aeropress' },
        { value: 'Cold Brew',        match: ['cold brew'],        label: 'Cold Brew / Overnight Steep' },
        { value: 'none', exclusive: true, label: "I don't use any equipment", desc: '' }
      ]
    },
    {
      id: 'flav', multi: true, max: 2,
      q: 'What kind of flavours do you like?',
      sub: 'Select up to 2.',
      // These must match custom.match_flavour_* exactly. Both are a locked
      // dropdown in the Shopify admin, so they cannot drift apart.
      opts: [
        { value: 'Dark & Bitter',     label: 'Dark & Bitter' },
        { value: 'Floral & Fruity',   label: 'Floral & Fruity' },
        { value: 'Smooth & Balanced', label: 'Smooth & Balanced' },
        { value: 'Chocolatey & Rich', label: 'Chocolatey & Rich' },
        { value: 'unsure', none: true, label: "I'm not sure", desc: "" }
      ]
    }
  ];

  /* ---------------------------------------------------------------- state */

  var state = { step: 0, know: [], style: [], equip: [], flav: [] };

  var overlay = document.getElementById('kmOverlay');
  var body    = document.getElementById('kmBody');
  var foot    = document.getElementById('kmFoot');
  var fill    = document.getElementById('kmFill');
  var stepLab = document.getElementById('kmStepLabel');
  var trigger = document.getElementById('kmTrigger');
  var lastFocus = null;

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  function track(name, payload) {
    if (typeof window.gtag === 'function') window.gtag('event', 'kaivo_match_' + name, payload || {});
    if (typeof window.fbq === 'function')  window.fbq('trackCustom', 'KaivoMatch_' + name, payload || {});
  }

  /* --------------------------------------------------------------- render */

  function render() {
    if (state.step >= STEPS.length || state.step === 99) { renderResult(); return; }

    var st = STEPS[state.step];
    var sel = state[st.id];

    fill.style.width = ((state.step + 1) / STEPS.length * 100) + '%';
    stepLab.textContent = 'Step ' + (state.step + 1) + ' of ' + STEPS.length;

    var h = '<div class="km-q">' + esc(st.q) + '</div>' +
            '<div class="km-sub">' + esc(st.sub) + '</div>' +
            '<div class="km-opts">';

    st.opts.forEach(function (o) {
      var on = sel.indexOf(o.value) > -1;
      var off = false;

      if (st.max && sel.length >= st.max && !on) off = true;
      if (st.id === 'equip') {
        if (o.exclusive && sel.length && !on) off = true;
        if (!o.exclusive && sel.indexOf('none') > -1) off = true;
      }

      h += '<button type="button" class="km-opt" data-v="' + esc(o.value) + '" ' +
           (st.multi ? 'aria-pressed="' + on + '"' : 'role="radio" aria-checked="' + on + '"') +
           (off ? ' disabled' : '') + '>' +
           '<span class="km-box"></span><span class="km-opt-t"><b>' + esc(o.label) + '</b>' +
           (o.desc ? '<span>' + esc(o.desc) + '</span>' : '') + '</span></button>';
    });

    body.innerHTML = h + '</div>';

    foot.innerHTML =
      (state.step > 0 ? '<button type="button" class="km-back" data-back>&#8592; Go back</button>' : '') +
      (st.multi
        ? '<button type="button" class="km-btn" data-next' + (sel.length ? '' : ' disabled') + '>Continue</button>'
        : '<a class="km-tlink" href="' + esc(DATA.allBlendsUrl) + '">View all blends</a>');

    body.querySelectorAll('.km-opt').forEach(function (el) {
      el.addEventListener('click', function () { pick(st, el.getAttribute('data-v')); });
    });
    wireFoot();
    body.scrollTop = 0;
  }

  function pick(st, value) {
    var sel = state[st.id];

    if (!st.multi) {
      state[st.id] = [value];
      if (st.id === 'know' && value === 'yes') {
        state.step = 99;
        setTimeout(render, 160);
        return;
      }
      setTimeout(function () { state.step++; render(); }, 160);
      return;
    }

    var i = sel.indexOf(value);
    if (i > -1) {
      sel.splice(i, 1);
    } else {
      if (st.id === 'equip') {
        if (value === 'none') state[st.id] = [];
        else if (sel.indexOf('none') > -1) return;
      }
      if (st.max && state[st.id].length >= st.max) return;
      state[st.id].push(value);
    }
    render();
  }

  function optsFor(id) {
    var step = STEPS.filter(function (s) { return s.id === id; })[0];
    return state[id].map(function (v) {
      return step.opts.filter(function (o) { return o.value === v; })[0];
    }).filter(Boolean);
  }

  /* --------------------------------------------------------------- result */

  function cardHTML(c, href) {
    return '<div class="km-card"><div class="km-meat">' +
      '<span class="km-cup">' + esc(c.cup) +
        (c.roast ? ' &middot; ' + esc(c.roast) : '') + '</span>' +
      '<h3>' + esc(c.name) + '</h3>' +
      (c.notes ? '<div class="km-notes">' + esc(c.notes) + '</div>' : '') +
      (c.line  ? '<div class="km-line">'  + esc(c.line)  + '</div>' : '') +
      '<div class="km-acts"><a class="km-btn" href="' + esc(href) + '">' +
        esc(DATA.cta || 'View blend') + '</a></div>' +
      '</div></div>';
  }

  // Pre-selects GRIND on the product page when the customer named exactly one
  // brewer this blend is listed for. Otherwise the page keeps its own default.
  function grindParam(blend) {
    var picked = optsFor('equip').filter(function (o) {
      return !o.exclusive && listHits(blend.equipment, [o]);
    });
    if (picked.length !== 1) return '';
    return 'GRIND=' + encodeURIComponent(picked[0].value);
  }

  function withParams(url, params) {
    var q = params.filter(Boolean).join('&');
    if (!q) return url;
    return url + (url.indexOf('?') > -1 ? '&' : '?') + q;
  }

  function renderResult() {
    fill.style.width = '100%';
    stepLab.textContent = '';

    var h = '', why = '', href = DATA.allBlendsUrl, card = null;

    if (state.step === 99) {
      var wild = BLENDS.filter(function (b) { return b.handle.indexOf('wildcard') > -1; })[0] || BLENDS[BLENDS.length - 1];
      h = '<div class="km-q">Then try the one you would never have picked.</div>' +
          '<div class="km-sub">You have already found your default. This is for when you want to be surprised anyway.</div>';
      card = wild; href = wild.url;
      why = 'The rotating lot. Not an everyday cup, and not meant to be.';
      body.innerHTML = h + '<div class="km-rescap">We think you&#8217;ll love</div>' +
        cardHTML(card, href) + '<div class="km-why">' + esc(why) + '</div>' +
        '<div class="km-resfoot"><span class="km-label">Rather browse?</span>' +
        '<a class="km-tlink" href="' + esc(DATA.allBlendsUrl) + '">View all blends</a></div>';
      renderFooter();
      track('completed', { result: card.handle, route: 'wildcard' });
      return;
    }

    var r = match(optsFor('style'), optsFor('equip'), optsFor('flav'));

    if (r.route === 'drip') {
      card = r.product; href = card.url;
      h = '<div class="km-rescap">No equipment, no problem</div>' + cardHTML(card, href);
      why = 'One sachet, one cup, nothing to set up. Hook it over your mug and pour.';

    } else if (r.route === 'sampler2') {
      var s2 = DATA.sampler2;
      // Both blends pre-selected on the product page.
      href = withParams(s2.url, [
        encodeURIComponent(s2.option1) + '=' + encodeURIComponent(r.pair[0].name),
        encodeURIComponent(s2.option2) + '=' + encodeURIComponent(r.pair[1].name)
      ]);
      card = {
        cup: s2.cup, name: s2.name, roast: s2.roast,
        notes: r.pair[0].name + '. ' + r.pair[1].name + '.', line: s2.line
      };
      h = '<div class="km-rescap">We think you&#8217;ll love</div>' + cardHTML(card, href);
      why = s2.why;

    } else if (r.route === 'sampler5') {
      var s5 = DATA.sampler5;
      href = s5.url;
      card = s5;
      h = '<div class="km-rescap">We think you&#8217;ll love</div>' + cardHTML(card, href);
      why = s5.why;

    } else {
      card = r.blend;
      href = withParams(card.url, [grindParam(card)]);
      h = '<div class="km-rescap">We think you&#8217;ll love</div>' + cardHTML(card, href);
    }

    body.innerHTML = h +
      (why ? '<div class="km-why">' + esc(why) + '</div>' : '') +
      '<div class="km-resfoot"><span class="km-label">Not sure?</span>' +
      '<a class="km-tlink" href="' + esc(DATA.allBlendsUrl) + '">View all blends</a></div>';

    renderFooter();
    track('completed', {
      route: r.route,
      result: (card && card.handle) || r.route,
      style: state.style.join('|'),
      equipment: state.equip.join('|'),
      flavour: state.flav.join('|')
    });
  }

  function renderFooter() {
    foot.innerHTML = '<button type="button" class="km-back" data-back>&#8592; Go back</button>' +
                     '<button type="button" class="km-btn" data-restart>Start over</button>';
    wireFoot();
    body.scrollTop = 0;
  }

  function wireFoot() {
    var back = foot.querySelector('[data-back]');
    if (back) back.addEventListener('click', function () {
      state.step = state.step === 99 ? 0 : Math.min(state.step, STEPS.length) - 1;
      if (state.step < 0) state.step = 0;
      render();
    });

    var next = foot.querySelector('[data-next]');
    if (next) next.addEventListener('click', function () {
      track('step', { step: state.step + 1 });
      state.step++;
      render();
    });

    var restart = foot.querySelector('[data-restart]');
    if (restart) restart.addEventListener('click', function () {
      state = { step: 0, know: [], style: [], equip: [], flav: [] };
      render();
    });
  }

  /* ----------------------------------------------------------- open/close */

  function openQuiz() {
    lastFocus = document.activeElement;
    overlay.hidden = false;
    if (trigger) trigger.hidden = true;
    document.body.style.overflow = 'hidden';
    render();
    var first = body.querySelector('.km-opt');
    if (first) first.focus();
    track('opened', {});
  }

  function closeQuiz() {
    overlay.hidden = true;
    if (trigger) trigger.hidden = false;
    document.body.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
    if (state.step < STEPS.length) track('abandoned', { step: state.step + 1 });
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target.closest('[data-kaivo-match]') : null;
    if (t) { e.preventDefault(); openQuiz(); }
  });

  var closeBtn = document.getElementById('kmClose');
  if (closeBtn) closeBtn.addEventListener('click', closeQuiz);

  overlay.addEventListener('click', function (e) { if (e.target === overlay) closeQuiz(); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !overlay.hidden) closeQuiz();
  });

  render();
})();
